<template>
  <el-button type="success" icon="el-icon-upload" @click="JumpTo">{{buttonname}}</el-button>
</template>

<script>
export default {
  name: 'ImportButton',
  props: {
    url: {
      type: String
    },
    buttonname: {
      type: String,
      default: '导入'
    }
  },
  methods: {
    JumpTo: function () {
      this.$router.push('/main' + this.url)
    }
  }
}
</script>

<style>
</style>
